module.exports = __webpack_public_path__ + "img/builder-12.99f141c4.webp";